import React from 'react'
import PropTypes from 'prop-types'
import {Row, Col, FormGroup, FormFeedback, Label, Input, Button} from 'reactstrap'

function renderValueInput(val, type, dict, handleChange, idx) {
  if (type === 'select') {
    return <Input
      type={type}
      name="value"
      value={val}
      onChange={(event) => {
        handleChange(event, idx, type)
      }}>
      <option/>
      {dict.map(o => <option key={o} value={o}>{o}</option>)}
    </Input>
  } else {
    const handleInputChange = (event) => {
      if (type === 'text' && val !== undefined) {
        const value = event.target.value
        if (value === '' || /^-?\d*\.?\d*$/.test(value)) {
          handleChange(event, idx, type)
        }
      } else {
        handleChange(event, idx, type)
      }
    }
    return <Input
      type={type}
      name="value"
      value={val}
      onChange={handleInputChange}
    />
  }
}

const propTypes = {
  valueArr: PropTypes.array.isRequired,
  inputDict: PropTypes.array.isRequired,
  dictValueKey: PropTypes.string,
  validationErrors: PropTypes.string,
  label: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleAdd: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  inputSettings: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  col: PropTypes.number,
}

const DynamicInputs = ({
  valueArr, inputDict, dictValueKey = 'id', validationErrors, label = 'Additional parameters',
  handleChange, handleAdd, handleDelete, inputSettings = 'text', col = null
}) => {
  let usedDataKeys = valueArr.map(data => data.key)
  let availableDataKeysDict = inputDict.filter(o => !usedDataKeys.includes(o[dictValueKey].toString()))
  return (
    <FormGroup>
      <Label>{label}</Label>
      {
        valueArr.map((data, idx) => {
          const dict = (data.key !== '' && inputDict.find(o => o[dictValueKey].toString() === data.key)) || {}
          const valueType = (typeof(inputSettings) === 'object' ? (inputSettings[dict.name] || {}).type : inputSettings)
          const valueDict = (valueType === 'select' ? inputSettings[dict.name].dict : [])

          return (<div key={idx}>
            <Row>
              <Col xs="12" sm={col || 5}>
                {data.key !== '' &&
                  <Input
                    type="select"
                    name="key"
                    disabled={true}
                    value={data.key}
                  >
                    <option
                      value={data.key}>{dict.label}</option>
                  </Input>}
                {data.key === '' &&
                  [<Input
                    key='empty'
                    type="select"
                    name="key"
                    value={data.key}
                    onChange={(event) => {
                      handleChange(event, idx)
                    }}
                  >
                    <option/>
                    {availableDataKeysDict.map(o => <option key={o.id}
                      value={o[dictValueKey]}>{o.label}</option>)}
                  </Input>,
                  <FormFeedback key='empty_info'>This field is required</FormFeedback>]
                }
              </Col>
              <Col xs="12" sm={col || 6}>
                {renderValueInput(data.value, valueType, valueDict, handleChange, idx)}
                {data.value === '' && <FormFeedback>This field is required</FormFeedback>}
              </Col>
              <Col sm="1">
                <Button
                  color="danger"
                  onClick={() => {
                    handleDelete(idx)
                  }}
                >
                  <i className="fa fa-minus"/>
                </Button>
              </Col>
            </Row>
          </div>)
        }
        )
      }
      <FormFeedback>{validationErrors}</FormFeedback>
      {availableDataKeysDict.length > 0 &&
      <Col sm="1">
        <Button
          color="primary"
          onClick={handleAdd}
          style={{marginTop: '5px'}}
        >
          <i className="fa fa-plus"/>
        </Button>
      </Col>}
    </FormGroup>
  )
}

DynamicInputs.propTypes = propTypes

export default DynamicInputs



// WEBPACK FOOTER //
// ./src/components/Support/dynamicInputs/DynamicInputs.js